import React from 'react';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import Analytics from 'utils/analytics';
import BatchUtils from '../utils';
import CommonStrings from 'resources/common-strings';
import CommonValues from 'resources/common-values';

import HelpBox from 'components/generic/help/index';
import HelpImage from './images/pages_help_callout.png';

export default CreateReactClass({
    displayName: 'batch-print-pages',

    PropTypes: {
        nextButtonAction: PropTypes.func,
        selectedModule: PropTypes.String,
        selectPages: PropTypes.func,
        selectGroupBy: PropTypes.func,
        selectedGroupByOption: PropTypes.oneOf([
            CommonValues.INSTRUCTION_AREAS_GROUPBY_TOPIC,
            CommonValues.INSTRUCTION_AREAS_GROUPBY_STANDARD,
        ]).isRequired,
        batchOptionState: PropTypes.bool.isRequired,
        displayPages: PropTypes.instanceOf(Immutable.List).isRequired,
    },

    getInitialState() {
        return {
            selectedPageForPrinting: Immutable.Set.of(this.props.selectedModule),
            groupBy: this.props.selectedGroupByOption,
        };
    },

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.selectedModule !== this.props.selectedModule) {
            this.setState({
                selectedPageForPrinting: Immutable.Set.of(nextProps.selectedModule),
            });
            this.props.selectPages(Immutable.Set.of(nextProps.selectedModule));
        }
        if (!nextProps.batchOptionState) {
            this.reset();
        }
    },

    reset() {
        this.setState(this.getInitialState());
    },

    togglePageChange(event, page) {
        const analyticsName = page == BatchUtils.displayPageNames.studentProfile ? 'student-profile-overview' : page;
        Analytics.recordButtonClick(CommonValues.SectionIDs.printAndShare, 'select-pages', analyticsName);

        let pages = this.state.selectedPageForPrinting;
        if (pages.includes(page)) {
            pages = pages.delete(page);
        } else {
            pages = pages.add(page);
        }
        this.setState({
            selectedPageForPrinting: pages,
        });
        this.props.selectPages(pages);
    },

    toggleGroupByChange(event, groupBy) {
        this.setState({
            groupBy: groupBy,
        });
        this.props.selectGroupBy(groupBy);
    },

    renderCheckboxSubOptions(pageInfo) {
        if (pageInfo.get('name') === BatchUtils.displayPageNames.instructionalAreas) {
            return (
                <div
                    className={
                        this.state.selectedPageForPrinting.includes('instructional-areas')
                            ? 'group-by active'
                            : 'group-by'
                    }
                >
                    <div>
                        <input
                            type="radio"
                            id="ia-print-group-by-topic-option"
                            checked={this.state.groupBy == CommonValues.INSTRUCTION_AREAS_GROUPBY_TOPIC}
                            onChange={(event) =>
                                this.toggleGroupByChange(event, CommonValues.INSTRUCTION_AREAS_GROUPBY_TOPIC)
                            }
                        />
                        <label htmlFor="ia-print-group-by-topic-option">Grouped by topic</label>
                    </div>
                    <div>
                        <input
                            type="radio"
                            id="ia-print-group-by-standard-option"
                            checked={this.state.groupBy == CommonValues.INSTRUCTION_AREAS_GROUPBY_STANDARD}
                            onChange={(event) =>
                                this.toggleGroupByChange(event, CommonValues.INSTRUCTION_AREAS_GROUPBY_STANDARD)
                            }
                        />
                        <label htmlFor="ia-print-group-by-standard-option">Grouped by standard</label>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    },

    renderPageCheckBox(pageInfo) {
        const pageName = pageInfo.get('name');
        const pageDisplayLabel = pageInfo.get('displayLabel');
        return (
            <div className="batch-option" key={`batch-option-${pageName}`}>
                <input
                    type="checkbox"
                    id={`print-pages-${pageName}-option`}
                    checked={this.state.selectedPageForPrinting.includes(pageName)}
                    onChange={(event) => this.togglePageChange(event, pageName)}
                />
                <label htmlFor={`print-pages-${pageName}-option`}>{pageDisplayLabel}</label>
                {this.renderCheckboxSubOptions(pageInfo)}
            </div>
        );
    },

    renderPageCheckBoxes() {
        let column1 = [],
            column2 = [];

        this.props.displayPages.forEach((displayPage) => {
            column1.push(this.renderPageCheckBox(displayPage));
        });

        return [column1, column2];
    },

    helpText() {
        return (
            <div key="batch-print-pages-help">
                <p key="batch-print-pages-help">
                    <span key="select-pages">{CommonStrings.printAndShareHelp.selectPages}</span>
                    <img className="pages-help" alt="help page" src={HelpImage} key="pagesImage" />
                </p>
            </div>
        );
    },

    render() {
        const containerClass =
            'button-container' + (this.state.selectedPageForPrinting.size == 0 ? ' show-tooltip' : '');
        const tooltip = <div className="tooltip">No page selected</div>;
        const arrow = <div className="tooltip arrow" />;

        let [column1, column2] = this.renderPageCheckBoxes();

        return (
            <div className="pages options-container">
                <div>
                    <h4>
                        SELECT PAGES
                        <HelpBox
                            id="batch-print-pages-content"
                            helpContentsRenderer={this.helpText}
                            isHelpBoxOpen={this.props.isHelpBoxOpen}
                            moduleName={CommonValues.SectionIDs.printAndShare}
                            placement="bottom"
                        />
                    </h4>
                    <div className="group-by-columns">
                        <div className="firstColumn">{column1}</div>
                        <div className="secondColumn">{column2}</div>
                    </div>
                </div>
                <div className={containerClass}>
                    <button
                        className="button-next"
                        onClick={(event) => this.props.nextButtonAction(event, 'students')}
                        disabled={this.state.selectedPageForPrinting.size == 0}
                    >
                        NEXT
                    </button>
                    {tooltip}
                    {arrow}
                </div>
            </div>
        );
    },
});
